<template>
  <div class="missions">
    <div class="header-container">
      <img
        class="majesticons-list-box"
        alt="Majesticons list box"
        src="/img/majesticons-list-box.svg"
      />
      <div class="header-text">La mission de SYMABIO</div>
    </div>
    <p class="body-text">
      Le SYMABIO a pour mission la défense des intérêts professionnels, sociaux et économiques des personnes physiques et morales exerçant une activité professionnelle dans les domaines de la production, de la cueillette, de la collecte ou du négoce, de la transformation, du conditionnement, de la commercialisation et de la certification des produits issus de l&#39;AB, ainsi que les intrants destinés à la production biologique.
      <br />
      <br />
      Le SYMABIO regroupe tous les professionnels de l&#39;Agriculture Biologique à Madagascar : producteurs, fournisseurs d&#39;intrants, transformateurs, distributeurs spécifiques, organismes certificateurs.
    </p>
  </div>
</template>

<script>
export default {
  name: "Missions",
};
</script>

<style>
.missions {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 32px;
  /* left: 130px; */
  /* position: absolute; */
  /* top: 1171px; */
  width: 32vw;
}

.missions .header-container {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  /* position: relative; */
}

.missions .majesticons-list-box {
  height: 32px;
  /* position: relative; */
  width: 32px;
}

.missions .header-text {
  color: #000000;
  font-family: "Bw Modelica SS02";
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 36px;
  /* margin-top: -1.00px; */
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}

.missions .body-text {
  align-self: stretch;
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;
  padding-left: 12px;
  /* position: relative; */
}
@media (max-width:1200px){
  .missions {
    width: 100%;
  }
}
</style>